import { IconContent } from '@icons';

export const caretDownFilled: IconContent = {
    sm: '<path fill-rule="evenodd" clip-rule="evenodd" d="M4 6.46547L7.69231 10H8.30769L12 6.46547V6H4V6.46547Z"/>',
    md: '<path d="M11.4794 16.0177L5.01782 9.05916V7.98224L19.0178 7.98224L19.0178 9.05916L12.5563 16.0177H11.4794Z"/>',
};
